import React from 'react'

const Box = ({icon}) => {
  return (
    <div className='bg-custom-yellow opacity-50 flex justify-center rounded pr-3 pl-3 h-[40px] w-[40px]'>
      <img className='h-full w-full opacity-100' src={icon} alt="icon" />
    </div>
  )
}

export default Box